import React from "react";

const HIGHLIGHTS = [
  { label: "Founded", value: "2024" },
  { label: "Learning Levels", value: "up to Class 8" },
  { label: "Focus", value: "Academics + Character" },
];

const SECTION_CARDS = [
  {
    title: "Mission",
    text: "To inspire and empower every student through an inclusive, high-quality educational experience that builds knowledge, confidence, and values for life.",
  },
  {
    title: "Vision",
    text: "To be a leading school community where curiosity, innovation, empathy, and responsibility shape lifelong learners and future-ready citizens.",
  },
  {
    title: "Our Faculty",
    text: "Our teachers are mentors and guides who use modern pedagogy, technology, and student-centered practices to help every child grow academically and personally.",
  },
];

const VALUES = [
  "Integrity and respect in every interaction.",
  "Academic rigor with joyful learning.",
  "Creativity, collaboration, and critical thinking.",
  "Community engagement and social responsibility.",
];

function AboutUs() {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-10">
      <div className="mx-auto max-w-6xl space-y-6">
        <section className="rounded-3xl bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 p-8 text-white shadow-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-100">
            About Us
          </p>
          <h1 className="mt-3 text-3xl font-semibold text-white sm:text-4xl">
            Growing Learners, Building Character
          </h1>
          <p className="mt-3 max-w-4xl text-sm leading-6 text-blue-100 sm:text-base">
            Rising Stars Public School was established with a clear vision: to
            create a nurturing and future-focused learning environment where
            students thrive academically, socially, and emotionally.
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-3">
            {HIGHLIGHTS.map((item) => (
              <article
                key={item.label}
                className="rounded-2xl border border-white/20 bg-white/10 p-4"
              >
                <p className="text-xs uppercase tracking-[0.2em] text-blue-100">
                  {item.label}
                </p>
                <p className="mt-2 text-lg font-semibold text-white">
                  {item.value}
                </p>
              </article>
            ))}
          </div>
        </section>

        <section className="grid gap-6 lg:grid-cols-[1.2fr_0.8fr]">
          <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-md">
            <h2 className="text-2xl font-semibold text-slate-900">
              Our History
            </h2>
            <p className="mt-3 text-sm leading-7 text-slate-700 sm:text-base">
              Rising Stars Public School was founded by Mr. Kirti Singh (Retd
              IFS) and Mrs. Santosh Singh (Secretary, Samaj Sewa Trust), who
              recognized the need for a school that combines timeless values
              with modern education.
            </p>
            <p className="mt-3 text-sm leading-7 text-slate-700 sm:text-base">
              From the beginning, our purpose has been clear: prepare students
              not only for examinations, but for life. We cultivate confidence,
              discipline, and curiosity so children are ready for both
              today&apos;s challenges and tomorrow&apos;s opportunities.
            </p>
          </article>

          <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-md">
            <h2 className="text-2xl font-semibold text-slate-900">
              Core Values
            </h2>
            <ul className="mt-4 space-y-3 text-sm text-slate-700 sm:text-base">
              {VALUES.map((value) => (
                <li
                  key={value}
                  className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
                >
                  {value}
                </li>
              ))}
            </ul>
          </article>
        </section>

        <section className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {SECTION_CARDS.map((item) => (
            <article
              key={item.title}
              className="rounded-3xl border border-slate-200 bg-white p-6 shadow-md"
            >
              <h2 className="text-2xl font-semibold text-slate-900">
                {item.title}
              </h2>
              <p className="mt-3 text-sm leading-7 text-slate-700 sm:text-base">
                {item.text}
              </p>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
}

export default AboutUs;
